import {initSliders} from 'slider';

class Fetch {
  constructor(elem) {
    this.fetchButton = elem;
    this.fetchContent = document.querySelector(`[data-fetch-content="${this.fetchButton.dataset.fetchButton}"]`);
    this.fetchUrl= elem.getAttribute('data-fetch-url');
    this.events();
  }

  events() {
    this.fetchButton.addEventListener('click', () => {
      fetch(this.fetchUrl)
        .then(response => response.json())
        .then(data => this.fetchContent.innerHTML = data.content)
        .then(data => initSliders());

    });
  }
}

const fetchButtons = document.querySelectorAll('[data-fetch-button]');

fetchButtons.forEach((fetchButton) => {
  fetchButton.fetch = new Fetch(fetchButton);
});

